const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

export const MAX_UPLOAD_BYTES = 10 * 1024 * 1024; // 10 MB

/** "2026-10-28T12:15+05:30" -> "28 Oct" (read as written, so it stays in the schedule's own timezone) */
export function fmtDate(iso?: string): string {
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(iso || "");
  return m ? `${+m[3]} ${MONTHS[+m[2] - 1]}` : "";
}

/** "2026-10-28T12:15+05:30" -> "12:15" */
export function fmtTime(iso?: string): string {
  const m = /T(\d{2}:\d{2})/.exec(iso || "");
  return m ? m[1] : "";
}

/** -> "28 Oct, 12:15–14:15" */
export function fmtWindow(start?: string, end?: string): string {
  return `${fmtDate(start)}, ${fmtTime(start)}\u2013${fmtTime(end)}`;
}

/** UTC timestamp -> "27 Oct, 18:25" in the given timezone */
export function fmtDateTime(iso?: string, timeZone = "Asia/Kolkata"): string {
  if (!iso) {
    return "";
  }
  const d = new Date(iso);
  if (isNaN(d.getTime())) {
    return "";
  }
  return d.toLocaleString("en-GB", {
    day: "numeric",
    month: "short",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
    timeZone,
  });
}

/** Returns an error message, or null if the file is acceptable. */
export function validateUpload(file: File): string | null {
  if (!/\.xlsx$/i.test(file.name)) {
    return "Please choose an Excel file (.xlsx).";
  }
  if (file.size === 0) {
    return "The selected file is empty.";
  }
  if (file.size > MAX_UPLOAD_BYTES) {
    return "The file is larger than 10 MB.";
  }
  return null;
}

/** Reads a file and returns raw base64 (no "data:...;base64," prefix). */
export function fileToBase64(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(String(reader.result).split(",").pop() || "");
    reader.onerror = () => reject(new Error("Unable to read the file."));
    reader.readAsDataURL(file);
  });
}

/** Builds a CSV string, quoting every cell. */
export function toCsv(header: string[], rows: any[][]): string {
  const esc = (v: any) => `"${String(v ?? "").replace(/"/g, '""')}"`;
  return [header, ...rows].map((r) => r.map(esc).join(",")).join("\n");
}

export function downloadText(filename: string, text: string, mime = "text/csv;charset=utf-8;") {
  const url = URL.createObjectURL(new Blob([text], { type: mime }));
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}